import React, { useEffect, useState } from "react";
import { Grid, Header, Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
import { reduxForm, Field } from "redux-form";

const formatDate = (inputDate) => {
  if (inputDate != null) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase();
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return formattedDate;
  } else {
    return null;
  }
};

const PurchaseList = (props) => {
  const { categoryId } = props;
  const navigate = useNavigate();
  const userDetail = userData();
  const [excelData, setExcelData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);

  useEffect(() => {
    getVisaList();
  }, []);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const filterDataSearch = () => {
    const filteredData = rowData.filter((data) => {
      const workDate = new Date(data.purchaseDate);
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);

      return workDate >= fromDateObj && workDate <= toDateObj;
    });

    setRowData(filteredData);
  };

  const getVisaList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listPurchase", {
        userId: userDetail.userId,
        categoryId: categoryId,
        listAll: categoryId == 0 && true,
      })
      .then((res) => {
        // Calculate the grand total
        const total = res.data.reduce(
          (acc, item) => acc + parseFloat(item.payment),
          0
        );

        // Add the grand total row
        const dataWithGrandTotal = res.data.map((item) => ({
          ...item,
          purchaseDate: item.purchaseDate
            ? new Date(item.purchaseDate).toLocaleDateString("en-GB")
            : "",
          chequePaymentDate: item.chequePaymentDate
            ? new Date(item.chequePaymentDate).toLocaleDateString("en-GB")
            : "",
          debitDate: item.debitDate
            ? new Date(item.debitDate).toLocaleDateString("en-GB")
            : "",
        }));

        // Set the grand total state
        setGrandTotal(total.toFixed(2));

        setRowData([
          ...dataWithGrandTotal,
          {
            purchaseDate: "",
            buyerCompany: "",
            description: "",
            payCompany: "",
            bankName: "",
            chequePaymentDate: "",
            debitDate: "Grand Total",
            payment: total.toFixed(2),
            toatl: "",
            remark: "",
          },
        ]);

        setDataForExcel([
          ...dataWithGrandTotal,
          {
            purchaseDate: "",
            buyerCompany: "",
            description: "",
            payCompany: "",
            bankName: "",
            chequePaymentDate: "",
            debitDate: "Grand Total",
            payment: total.toFixed(2),
            toatl: "",
            remark: "",
          },
        ]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setDataForExcel = (record) => {
    const tempRecord = record.map(
      ({
        purchaseDate,
        buyerCompany,
        buyerAccountNumber,
        description,
        payCompany,
        bankName,
        chequePaymentDate,
        debitDate,
        payment,
        toatl,
        remark,
      }) => ({
        purchaseDate: purchaseDate
          ? new Date(purchaseDate).toLocaleDateString("en-GB")
          : "",

        buyerCompany,
        buyerAccountNumber,
        description,
        payCompany,
        bankName,
        chequePaymentDate: chequePaymentDate
          ? new Date(chequePaymentDate).toLocaleDateString("en-GB")
          : "",
        debitDate: debitDate
          ? new Date(debitDate).toLocaleDateString("en-GB")
          : "",
        payment,
        toatl,
        remark,
      })
    );

    setExcelData(tempRecord);
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    filter: true,
    floatingFilter: true,
  };

  const columnDefs = [
    { headerName: "Purchase Date", field: "purchaseDate" },
    { headerName: "Buyer Company", field: "buyerCompany" },
    { headerName: "Description", field: "description" },
    { headerName: "Pay Company", field: "payCompany" },
    { headerName: "Bank Name", field: "bankName" },
    { headerName: "Cheque Payment Date", field: "chequePaymentDate" },
    { headerName: "Debit Date", field: "debitDate" },
    { headerName: "Payment", field: "payment" },
    { headerName: "Total", field: "toatl" },
    { headerName: "Remark", field: "remark" },
    {
      headerName: "Edit/Delete",
      filter: false,
      field: "purchaseId",
      cellRendererFramework: (params) => {
        if (params.data.debitDate === "Grand Total") {
          // No delete button for the grand total row
          return null;
        }

        return (
          <div>
            <Button color="primary" onClick={() => editRecord(params)}>
              <AiFillEdit />
            </Button>
            {userDetail.userRole == 1 && (
              <Button color="red" onClick={() => deleteRecord(params)}>
                <AiFillDelete />
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const editRecord = (params) => {
    console.log(params.data);
    navigate(`/create-purchase/${params.data.purchaseId}/${categoryId}`);
  };

  const deleteRecord = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(BaseUrlInvoice + "/accounts/deletePurchase", {
            purchaseId: params.data.purchaseId,
          })
          .then((res) => {
            Swal.fire("Deleted!", "Purchase has been deleted.", "success");
            getVisaList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div>
      <br />
      <Grid.Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {categoryId != 0 && (
              <Button
                color="primary"
                onClick={() => navigate(`/create-purchase/null/${categoryId}`)}
              >
                Create New
              </Button>
            )}

            <Button
              color="primary"
              onClick={(e) => exportToCSV(excelData, "PURCHASE_LIST")}
            >
              Export Excel
            </Button>
          </div>
        </div>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default PurchaseList;
